import AccomodationService from '@services/accomodation.service';
import { useEffect, useState, useContext } from 'react';
import { Table, Badge, OverlayTrigger, Tooltip } from "react-bootstrap"
import { t } from 'i18next'
import PaginationComponent from './typescript/PaginationComponent';
import Dropdown from 'react-bootstrap/Dropdown';
import React from 'react';
import { useNavigate } from 'react-router';
import DeleteModal from './typescript/DeleteModal';
import { getToastStore } from '@utils/ToastStore';
import BootstrapSpinner from './typescript/BootstrapSpinner';
import { useSpinner } from '@webkit/components/typescript/SpinnerContext';
import { CreditsContext } from '@utils/GlobalContext.js';
import ActivationModal from './typescript/ActivationModal';
import EmailSenderModal from './typescript/EmailSenderModal';
import AppEnviroment from "app-enviroment";

const objOrder = {
    name: "asc",
    creationDate: "asc",
    updateDate: "asc",
    active: "asc"
}

const tableHeaders = [
    {
        name: "name",
        label: t(`label.name`)
    },
    {
        name: "creationDate",
        label: t(`label.creation_date`)
    },
    {
        name: "updateDate",
        label: t(`label.update_date`)
    },
    {
        name: "active",
        label: t(`label.status`)
    }

]

const params = {
    page: 0,
    size: 10,
    sort: "creationDate,desc"
}

const CustomToggle = React.forwardRef(({ onClick }, ref) => (
    <i
        ref={ref}
        role="button"
        className="fa-solid fa-ellipsis-vertical text-secondary"
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        style={{ cursor: "pointer", width: "2rem" }}
    />
));

const SmartTable = () => {
    const creditsCtx = useContext(CreditsContext);
    const ctxToast = getToastStore();
    const [reload, setReload] = useState(false)
    const [response, setResponse] = useState(undefined)
    const [elementsOrder, setElementsOrder] = useState(objOrder)
    const [finalSort, setFinalSort] = useState(params)
    const [spinnerActive, setSpinnerActive] = useState(false)
    const [actualSort, SetActualSort] = useState(params.sort)
    const navigate = useNavigate();
    const [seeModal, setSeeModal] = useState(false)
    const [seeModalActivate, setSeeModalActivate] = useState(false)
    const ctx = getToastStore();
    const [idAccomodationRemove, setIdAccomodationRemove] = useState(0)
    const [idAccomodationVisbility, setIdAccomodationVisbility] = useState(0)
    const { showSpinner, hideSpinner } = useSpinner();
    //email sender var
    const [seeEmailSenderModal, setSeeEmailSenderModal] = useState(false)
    const [accomodationId, setaccomodationId] = useState(0)
    const [accomodationQrCodeId, setaccomodationQrCodeId] = useState("");
    const pwaUrl = AppEnviroment.getPwaUrl();
    
    useEffect(() => {
        orderTable(finalSort)
    }, [finalSort, reload]);

    async function orderTable(sort) {
        window.scrollTo({ top: 0 });
        showSpinner()
        setSpinnerActive(true)
        try {
            const response = await AccomodationService.findAccomodationAssociated(sort)
            setResponse(response);
        } catch (error) {
            console.log(error);
        } finally {
            setSpinnerActive(false)
            hideSpinner()
        }
    }

    if (!response) return null
    const { content } = response

    function orderColumn(column) {
        const newOrder = Object.fromEntries(
            Object.keys(elementsOrder).map(key => [
                key,
                key === column
                    ? (elementsOrder[key] === "desc" ? "asc" : "desc")
                    : "asc"
            ])
        );
        setElementsOrder(newOrder)
        const newSort = `${column},${newOrder[column]}`
        SetActualSort(newSort)
        const newFinalSort = { ...finalSort }
        newFinalSort.sort = newSort
        setFinalSort(newFinalSort);
    }

    const deleteAccomodation = async (e) => {
        e.preventDefault()
        try {
            showSpinner()
            const response = await AccomodationService.deleteAccomodation(idAccomodationRemove)
            const msg = response?.message || t("success.successfull_delete")
            ctx.setToastMsg(msg)
            ctx.setSeeToast(true)
            ctx.setErrorToast(false)
            setSeeModal(false)
            const newSort = { ...finalSort }
            newSort.page = 0
            orderTable(newSort)
            setFinalSort(newSort)
        } catch (error) {
            console.error(error)
        } finally {
            hideSpinner()
        }
    }

    const handleStatus = async (e) => {
        
        try {
            await AccomodationService.changeVisibility(idAccomodationVisbility);
            setReload(!reload)
            setSeeModalActivate(false)
            await creditsCtx.refreshCredits();
        } catch (err) {
            const errorMessage = err?.response?.data?.message 
                || err?.message 
                || t("error.load_credit");
            if (ctxToast) {
                ctxToast.setToastMsg(errorMessage);
                ctxToast.setSeeToast(true);
                ctxToast.setErrorToast(true);
            } else {
                alert(err);
            }
        }
    }

    const dowloadQrcodeId = async (accomodationId) => {
        try {
            showSpinner()
            const blob = await AccomodationService.dowloadQrcodeId(accomodationId)
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'qrcode.png';
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error)
        } finally {
            hideSpinner()
        }
    }

    const whatsappShare= (id)=>{
        const msg = `${t("text.whatsapp")} https://hostyble.netlify.app/open-app?qrCodeId=${encodeURIComponent(id)}`
        const urlWhatsApp = `https://wa.me/?text=${encodeURIComponent(msg)}`;
        window.open(urlWhatsApp, '_blank');
    }

    return (
        <div className='mx-4'>
            <div className='d-flex flex-column justify-content-center'>
                <h2 style={{ color: "var(--primary-color)", marginBottom: "16px", width: "90%" }}>{t('title.my_hostyble')}</h2>
                <p>{t("page_description.accommodation_list")}</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }} className='relative'>
                {spinnerActive && <BootstrapSpinner />}
                <div className="card shadow-lg" style={{ width: '100%', borderRadius: '25px' }}>
                    <Table striped hover align="middle" className="table-style mb-0">
                        <thead className='table-style'>
                            <tr>{tableHeaders ?
                                tableHeaders.map((header, index) => {
                                    return <th key={index} onClick={() => orderColumn(header.name)} className={`text-center header-tab ${index === 0 ? 'radius-top-left' : ''}`}>
                                        <span>{header.label}</span>
                                        {header.name === actualSort.split(',')[0] ?
                                            <span >
                                                {
                                                    actualSort.split(',')[1] === "desc" ?
                                                        <i className="ms-2 fa-solid fa-arrow-up"></i> :
                                                        <i className="ms-2 fa-solid fa-arrow-down"></i>
                                                }
                                            </span> : <></>}
                                    </th>
                                }) : null}
                                <th className="header-tab radius-top-right text-center">{t("label.action")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {content.map((accomodation) => (
                                <tr key={accomodation?.id}>
                                    <td className='text-center'>{accomodation?.name}</td>
                                    <td className='text-center'>{new Date(accomodation?.creationDate).toLocaleDateString()}</td>
                                    <td className='text-center'>{accomodation?.updateDate ? new Date(accomodation?.updateDate).toLocaleDateString() : " - "}</td>
                                    <td className='text-center'>
                                        {accomodation?.active ? (
                                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-eye">{t('button.disable_accomodation')}</Tooltip>}>
                                                <Badge onClick={() => {
                                                    setSeeModalActivate(true)
                                                    setIdAccomodationVisbility(accomodation?.id)
                                                }} bg="" className='badge-teal hst-cursor-pointer'>{t('label.active')}</Badge>
                                            </OverlayTrigger>
                                        ) : (
                                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-eye">{t('button.enable_accomodation')}</Tooltip>}>
                                                <Badge onClick={() => {
                                                    setSeeModalActivate(true)
                                                    setIdAccomodationVisbility(accomodation?.id)
                                                }} bg="danger" className='hst-cursor-pointer'>{t('label.inactive')}</Badge>
                                            </OverlayTrigger>
                                        )}
                                    </td>
                                    <td className='text-center'>
                                        <Dropdown align="end">
                                            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom" />

                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => navigate(`/new-app/${accomodation?.id}`)}>
                                                    {t('button.edit')}
                                                </Dropdown.Item>
                                                <Dropdown.Item onClick={() => {
                                                    setSeeModal(true)
                                                    setIdAccomodationRemove(accomodation?.id)
                                                }}>
                                                    {t('button.delete')}
                                                </Dropdown.Item>
                                                <Dropdown.Item onClick={() => {
                                                    setSeeModalActivate(true)
                                                    setIdAccomodationVisbility(accomodation?.id)
                                                }}>
                                                    {t('button.active_deactivate')}
                                                </Dropdown.Item>
                                                {accomodation?.active ? <>
                                                <Dropdown.Item onClick={() => {
                                                    dowloadQrcodeId(accomodation?.id)
                                                }}>
                                                    {t('button.dowload_qr')}
                                                </Dropdown.Item>
                                                <Dropdown.Item onClick={() => {
                                                    setaccomodationQrCodeId(accomodation?.qrCodeId)
                                                    setaccomodationId(accomodation?.id)
                                                    setSeeEmailSenderModal(true)
                                                }}>
                                                    {t('button.share_email')}
                                                </Dropdown.Item>
                                                <Dropdown.Item onClick={() => {
                                                    whatsappShare(accomodation?.qrCodeId)
                                                }}>
                                                    {t('button.share_whatsapp')}
                                                </Dropdown.Item>
                                                <Dropdown.Item onClick={() => {
                                                    window.open(`${pwaUrl}${accomodation?.qrCodeId}`, '_blank')
                                                }}>
                                                    {t('button.see_site')}
                                                </Dropdown.Item>
                                                </>: <></>}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <div
                        className="card-footer"
                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                        {response ? <PaginationComponent data={response} func={setFinalSort} obj={finalSort} /> : <></>}

                        <DeleteModal
                            showModal={seeModal}
                            setShowModal={setSeeModal}
                            title={t("title.delete_accomodation")}
                            deleteFunction={deleteAccomodation}
                        />
                        <ActivationModal
                            modalActivate={seeModalActivate}
                            setSeeModalActivate={setSeeModalActivate}
                            handleStatus={handleStatus}
                        />
                        <EmailSenderModal
                            seeModal={seeEmailSenderModal}
                            setSeeModal={setSeeEmailSenderModal}
                            id={accomodationId}
                            qrCodeId={accomodationQrCodeId}
                        />
                    </div>
                </div>
            </div>
        </div>
    )

}

export default SmartTable;